import { AppEnvironment } from "./enviroment.util";

export class Security{
    private static readonly localCurrentUserKey = "currentUser"
    private static readonly localAdKey = `msal.${new AppEnvironment().AzureClientID}.idtoken`;

    public static validouAD(): boolean{
        let tokenAd = sessionStorage.getItem(this.localAdKey);
        return tokenAd !== null;
    }

    public static retornaTokenAD(){
        return sessionStorage.getItem(this.localAdKey);
    }

    public static validouPAG(): boolean{
        let tokenCurrentUser = sessionStorage.getItem(this.localCurrentUserKey);
        return tokenCurrentUser !== null;
    }

    public static removeTokenAd(){
        sessionStorage.clear();
    }
}